import { render, staticRenderFns } from "./PayServiceDetailFooter.vue?vue&type=template&id=136e9608&scoped=true"
import script from "./PayServiceDetailFooter.vue?vue&type=script&lang=ts"
export * from "./PayServiceDetailFooter.vue?vue&type=script&lang=ts"
import style0 from "./PayServiceDetailFooter.vue?vue&type=style&index=0&id=136e9608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e9608",
  null
  
)

export default component.exports